import { IExtendedFetchResult, RequestMethods } from 'networking/fetchConfig';
import { ICatalog } from 'types/productCatalogTypes';

import { productCatalogFetch } from './productCatalogFetch';

export function getCatalogs(): Promise<IExtendedFetchResult<ICatalog[]>> {
  return productCatalogFetch<ICatalog[]>(RequestMethods.GET, `/v2/catalogs`);
}
